import React from 'react';
import { Link } from 'react-router-dom';
import './TreatmentPage.css';

import mainSportsOrthopaedics   from '../assets/images/mainSportsOrthopaedics.png';
import AdvancedRegenerative_b from '../assets/images/AdvancedRegenerative_b.png';

export default function Physiotherapy() {
  return (
    <div>
      <section className="tx-hero" style={{backgroundImage:"url(https://images.unsplash.com/photo-1616279969965-ee85e3e4ffd3?w=1400&q=80)"}}>
        <div className="tx-hero-overlay" style={{background:'linear-gradient(135deg,rgba(60,20,120,0.92) 0%,rgba(100,40,180,0.82) 50%,rgba(0,120,170,0.75) 100%)'}}/>
        <div className="container tx-hero-content">
          <div className="breadcrumb"><Link to="/">Home</Link><span className="sep">›</span><span>Physiotherapy</span></div>
          <span className="tx-hero-badge" style={{background:'#7C3AED33',color:'#fff'}}>Active Recovery</span>
          <h1>Sports Physiotherapy &amp; Rehabilitation</h1>
          <p>Evidence-based rehabilitation, sports performance programs and injury prevention for athletes and active individuals.</p>
          <div style={{display:'flex',gap:14,marginTop:28,flexWrap:'wrap'}}>
            <Link to="/contact" className="btn-acc" style={{background:'#7C3AED'}}>Book Session →</Link>
            <a href="#services" className="btn-ghost-w">View Services</a>
          </div>
        </div>
      </section>

      <section className="section" style={{background:'#F8FAFC'}}>
        <div className="container">
          <div className="intro-grid">
            <div>
              <div className="tag-line"><span>Rehabilitation</span></div>
              <h2 className="sec-title">Rebuild Strength. <span className="acc">Restore Function.</span></h2>
              <p style={{fontSize:15.5,color:'#475569',lineHeight:1.8,marginBottom:16}}>Our physiotherapy division is focused on restoring your body to full function — whether you're recovering from an injury, surgery, or working to prevent future issues. We use evidence-based methods tailored to your specific sport and goals.</p>
              <p style={{fontSize:15.5,color:'#475569',lineHeight:1.8,marginBottom:28}}>From elite athletes to weekend warriors, our physiotherapy team builds structured programs that accelerate recovery, rebuild strength, and give you the confidence to return to activity safely.</p>
              <div className="benefit-list">
                <div className="benefit-item"><span className="b-check" style={{background:'#EDE9FE',color:'#7C3AED'}}>✓</span>Sports-specific rehab protocols</div>
                <div className="benefit-item"><span className="b-check" style={{background:'#EDE9FE',color:'#7C3AED'}}>✓</span>Post-surgical rehabilitation</div>
                <div className="benefit-item"><span className="b-check" style={{background:'#EDE9FE',color:'#7C3AED'}}>✓</span>Performance optimisation</div>
                <div className="benefit-item"><span className="b-check" style={{background:'#EDE9FE',color:'#7C3AED'}}>✓</span>Injury prevention programs</div>
                <div className="benefit-item"><span className="b-check" style={{background:'#EDE9FE',color:'#7C3AED'}}>✓</span>Manual therapy & dry needling</div>
                <div className="benefit-item"><span className="b-check" style={{background:'#EDE9FE',color:'#7C3AED'}}>✓</span>Progressive strength training</div>
              </div>
            </div>
            <div className="intro-img">
              <img src="https://images.unsplash.com/photo-1591343395082-e120087004b4?w=700&q=80" alt="Physiotherapy session" style={{borderRadius:20,width:'100%',height:420,objectFit:'cover'}}/>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="section">
        <div className="container">
          <div style={{textAlign:'center',marginBottom:52}}>
            <div className="tag-line" style={{justifyContent:'center'}}><span>Our Services</span></div>
            <h2 className="sec-title" style={{textAlign:'center'}}>Physiotherapy <span className="acc">Services</span></h2>
          </div>

          <div className="proc-row">
            <div className="proc-img"><img src={mainSportsOrthopaedics} alt="Sports Physiotherapy"/></div>
            <div className="proc-text">
              <div className="proc-num" style={{color:'#7C3AED'}}>01</div>
              <h3>Sports Physiotherapy</h3>
              <p>Specialised physiotherapy designed for sports injuries — from acute muscle strains and ligament sprains to chronic overuse conditions. Our sports physiotherapists understand the biomechanics of different sports and design treatment plans accordingly.</p>
              <p style={{marginTop:12}}>Whether you play cricket, football, badminton, or run marathons, our programmes are built around the demands of your sport and your timeline to return.</p>
              <div className="proc-chips" style={{'--chip-bg':'#EDE9FE','--chip-color':'#7C3AED'}}>
                <span>Muscle Strains</span><span>Ligament Sprains</span><span>Overuse Injuries</span><span>Return to Sport</span>
              </div>
            </div>
          </div>

          <div className="proc-row reverse">
            <div className="proc-img"><img src={AdvancedRegenerative_b} alt="Sports Rehabilitation"/></div>
            <div className="proc-text">
              <div className="proc-num" style={{color:'#7C3AED'}}>02</div>
              <h3>Sports Rehabilitation</h3>
              <p>Structured post-injury and post-surgical rehabilitation programs that take you from initial recovery through to full performance. Our progressive rehab protocol ensures each phase of healing is addressed — pain control, range of motion, strength, and sport-specific function.</p>
              <p style={{marginTop:12}}>Particularly effective after ACL reconstruction, knee replacement, rotator cuff repair, and other orthopaedic procedures performed by Dr. Sadhan Palakuri.</p>
              <div className="proc-chips">
                <span>Post-Surgical Rehab</span><span>ACL Rehab</span><span>Joint Replacement Rehab</span><span>Shoulder Rehab</span>
              </div>
            </div>
          </div>

          <div className="proc-row">
            <div className="proc-img"><img src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=600&q=80" alt="Strength Training"/></div>
            <div className="proc-text">
              <div className="proc-num" style={{color:'#7C3AED'}}>03</div>
              <h3>Strength Training &amp; Conditioning</h3>
              <p>Progressive strength and conditioning programmes designed to build muscular resilience, correct imbalances, and protect your joints from future injury. These programmes are science-backed and tailored to your current fitness level and goals.</p>
              <p style={{marginTop:12}}>Whether you're a competitive athlete wanting to perform at a higher level, or someone who wants to stay active without injury, our strength conditioning protocols deliver measurable results.</p>
              <div className="proc-chips">
                <span>Strength Building</span><span>Injury Prevention</span><span>Athletic Performance</span><span>Core Stability</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{background:'#F8FAFC'}}>
        <div className="container">
          <div style={{textAlign:'center',marginBottom:44}}>
            <div className="tag-line" style={{justifyContent:'center'}}><span>Conditions Treated</span></div>
            <h2 className="sec-title" style={{textAlign:'center'}}>Conditions We <span className="acc">Treat</span></h2>
          </div>
          <div className="cond-grid">
            {['Post-Surgical Rehabilitation','Sports Performance Optimisation','Muscle Strains & Tears','Lower Back Pain','Neck Pain','Shoulder Impingement','Knee Rehab','Hip Tightness','Achilles Tendinopathy','Patellofemoral Syndrome','Strength Deficits','Balance & Coordination','Postural Problems','Gait Disorders','Sports-Specific Conditioning','Work-Related Injuries'].map(c=>(
              <div key={c} className="cond-chip">{c}</div>
            ))}
          </div>
        </div>
      </section>

      <section style={{background:'#7C3AED',padding:'72px 0',textAlign:'center'}}>
        <div className="container">
          <h2 style={{fontSize:'clamp(26px,3vw,38px)',fontWeight:800,color:'#fff',marginBottom:16}}>Ready to Rebuild Your Strength?</h2>
          <p style={{fontSize:16,color:'rgba(255,255,255,0.78)',maxWidth:500,margin:'0 auto 32px'}}>Book a physiotherapy assessment and start your recovery or performance programme today.</p>
          <Link to="/contact" className="btn-acc" style={{fontSize:16,padding:'14px 32px',background:'#fff',color:'#7C3AED'}}>Book Session →</Link>
        </div>
      </section>
    </div>
  );
}
